"use strict";
exports.__esModule = true;
exports["default"] = (function (url) {
    if (typeof url === 'string')
        url = new URL(url);
    var domain = url.hostname;
    var elems = domain.split('.');
    var iMax = elems.length - 1;
    var elem1 = elems[iMax - 1];
    var elem2 = elems[iMax];
    var isSecondLevelDomain = iMax >= 3 && (elem1 + elem2).length <= 5;
    return (isSecondLevelDomain ? elems[iMax - 2] + '.' : '') + elem1 + '.' + elem2;
});
